import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Microphone = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 22C12.691 22 10 19.308 10 16V8C10 4.692 12.691 2 16 2C19.309 2 22 4.692 22 8V16C22 19.308 19.308 22 16 22ZM16 4C13.794 4 12 5.794 12 8V16C12 18.206 13.794 20 16 20C18.206 20 20 18.206 20 16V8C20 5.794 18.206 4 16 4Z" />
		<path d="M25 12C24.448 12 24 12.448 24 13V16C24 20.411 20.411 24 16 24C11.589 24 8 20.411 8 16V13C8 12.448 7.552 12 7 12C6.448 12 6 12.448 6 13V16C6 21.177 9.954 25.447 15 25.95V28H13C12.448 28 12 28.448 12 29C12 29.552 12.448 30 13 30H19C19.552 30 20 29.552 20 29C20 28.448 19.552 28 19 28H17V25.95C22.046 25.447 26 21.177 26 16V13C26 12.448 25.552 12 25 12Z" />
	</svg>
);

export default Microphone;
